import React from 'react';
import { AdminCampaignTypes, CampaignType, GamicType } from './types';
import { formatLocalDate } from '@/utils/FormateLocalDate';
import CardByGender from './components/CardByGender';
import CardByFollower from './components/cardByFollower';
import RemoteFile from '@/helper/RemoteFile';



interface Props {
  campaignData: CampaignType;
  gamic: GamicType
}

const CampaignInsight: React.FC<Props> = ({
  campaignData,
gamic
}) => {
  const topMetrics: [string, string][] = [
    ['CPE', `$ ${campaignData?.cpe ?? 0}`],
    ['CPD', `$ ${campaignData?.cpd ?? 0}`],
    ['Total Budget', `$ ${campaignData?.total_budget ?? 0}`],
    ['Spent', `$ ${campaignData?.spent ?? 0}`],
  ];

  const analytics: [string, React.ReactNode][] = [
    ['Total', campaignData?.engagements ?? 0],
    ['Likes', campaignData?.likes ?? 0],
    ['Shares', campaignData?.shares ?? 0],
    ['Comments', campaignData?.comments ?? 0],
    ['Downloads', campaignData?.downloads ?? 0],
    ['Wishlist', campaignData?.wishlists ?? 0],
  ];

  return (
    <div className='flex  p-6 space-x-[32px]'>
      {/* Left side - Campaign Details */}
      <div className='flex-1 bg-[#f5f5f5] p-6 rounded-[16px] overflow-auto'>
        <div className='w-full'>
          {/* gamic title pill */}
          <div className='flex mb-4'>
            <span className='rounded-full text-xl font-bold'>
              Insights
            </span>
          </div>

          {/* date & campaign */}
          <div className='flex items-start justify-between '>
            <div>
              {/* <div className='text-[#515151] text-base'>{dateRange}</div> */}
              <div className='font-medium'>Date Range</div>
            </div>
            <div className='text-right'>
              {/* <div className='text-[#515151] text-base'>{campaignName}</div> */}
              <div>{`${formatLocalDate(campaignData.start_date)} - ${formatLocalDate(campaignData.end_date)}`}</div>
            </div>
          </div>

          {/* divider */}
          <div className='mb-[15px] h-px bg-gray-200' />

          {/* top metrics */}
          <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 mb-4'>
            {topMetrics.map(([label, value]) => (
              <div key={label} className='bg-white rounded-2xl p-4'>
                <div className='text-[#515151] text-sm'>{label}</div>
                <div className='font-bold'>{value}</div>
              </div>
            ))}
          </div>

          {/* divider */}
          <div className='my-[10px] h-px bg-gray-200' />

          {/* analytics list */}
          <div className='text-sm font-semibold mb-2'>Analytics</div>
          <div className='grid grid-cols-2 gap-1 mb-4'>
            {analytics.map(([label, value]) => (
              <React.Fragment key={label}>
                <div className='text-sm'>{label}</div>
                <div className='text-sm font-semibold text-[#FF0050] text-right'>
                  {value}
                </div>
              </React.Fragment>
            ))}
          </div>

          {/* divider */}
          <div className='my-[10px] h-px bg-gray-200' />

          <div className='flex mb-4'>
            <span className='rounded-full text-xl font-bold'>
              Engagement Comparison
            </span>
          </div>

          {/* cards carousel */}
          <div className='flex space-x-2 w-full mb-4'>
            <CardByFollower
              engagements={campaignData?.engagements}
              followers={campaignData?.followers}
            />
          </div>
          <div className='flex space-x-2 w-full'>
            <CardByGender
              engagements={campaignData?.engagements}
              male={campaignData?.males}
              female={campaignData?.females}
            />
          </div>
        </div>
      </div>

      {/* Right side - Live Preview */}
<div className=' flex-1 flex flex-col justify-center bg-[#f5f5f5] p-6 rounded-[16px]'>
        <h2 className='text-2xl font-bold mb-4'>Live Preview</h2>
          <RemoteFile
            className='h-full w-full '
            keyPath={gamic.file_url}
            key={gamic.title}
          />
      </div>
    </div>
  );
};

export default CampaignInsight;
